<template>
  <!-- 다이얼로그들 -->
  <dialog_caView v-if="useViewDialog" :p_solution="selectedSolution" :closeFunction="viewDialogOnOff" />
  <dialog_caEdit v-if="useEditDialog" :p_solution="selectedSolution" :closeFunction="editDialogOnOff" :reload="reloadPage" />
  <dialog_customerRegister 
    v-if="showCustomerRegister" 
    :registerDialogSwitch="customerRegisterSwitch"
    :reloadForSync="handleCustomerRegistered"
  />
  <dialog_planView 
    v-if="showPlanView" 
    :plan-idx="selectedPlanIdx" 
    :close-function="closePlanView" 
  />
  <dialog_customerPicker 
    v-if="showCustomerPicker" 
    @submit="handleCustomerSelect" 
  />

  <!-- Toast Notification -->
  <Transition name="toast">
    <div v-if="toast.show" class="toast" :class="toast.type">
      <i :class="toast.icon"></i>
      <span>{{ toast.message }}</span>
    </div>
  </Transition>

  <!-- 솔루션 타입 선택 다이얼로그 -->
  <Transition name="modal">
    <div v-if="showSolutionTypeSelector" id="dialog-solutionTypeSelector">
      <div class="dialog-backdrop" @click="showSolutionTypeSelector = false"></div>
      <div class="dialog-content">
        <div class="paper-small">
          <div class="header-small">
            <div class="header-icon">
              <i class="ph-bold ph-chart-pie-slice"></i>
            </div>
            <div class="header-text">
              <h2>분석 시작하기</h2>
              <p>고객의 보장 현황을 분석하고 최적의 보험 설계를 제안합니다</p>
            </div>
            <button class="close-btn-small" @click="showSolutionTypeSelector = false">
              <i class="ph-bold ph-x"></i>
            </button>
          </div>
          
          <div class="options">
            <button class="option-btn" @click="openCustomerRegister()">
              <div class="option-icon new">
                <i class="ph-bold ph-user-plus"></i>
              </div>
              <div class="option-content">
                <span class="option-title">새 고객 등록</span>
                <p class="option-desc">새로운 고객 정보를 입력하고 분석을 시작합니다</p>
              </div>
              <i class="ph ph-arrow-right option-arrow"></i>
            </button>
            
            <button class="option-btn" @click="openCustomerPicker()">
              <div class="option-icon existing">
                <i class="ph-bold ph-user-check"></i>
              </div>
              <div class="option-content">
                <span class="option-title">기존 고객 선택</span>
                <p class="option-desc">등록된 고객 목록에서 선택하여 분석합니다</p>
              </div>
              <i class="ph ph-arrow-right option-arrow"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <div id="module-CA-main" :class="{ 'is-loading': loading }">

    <!-- Loading Overlay -->
    <Transition name="fade">
      <div id="loading-paper" v-if="loading">
        <div class="loading-content">
          <div class="loading-spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
          </div>
          <h2>{{ loadingMent }}</h2>
          <div class="progress-wrapper">
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: `${(loadPrg / laodMax) * 100}%` }"></div>
            </div>
            <span class="progress-text">{{ loadPrg }} / {{ laodMax }}</span>
          </div>
        </div>
      </div>
    </Transition>

    <!-- 상단 네비게이션 -->
    <div class="top-nav">
      <div class="nav-left">
        <!-- 48x48 탭 버튼들 -->
        <div class="nav-tabs">
          <button 
            class="nav-tab" 
            :class="{ active: activeTab === 'workspace' }"
            @click="activeTab = 'workspace'"
            title="내 작업"
          >
            <i class="ph-fill ph-briefcase"></i>
          </button>
          <button 
            class="nav-tab" 
            :class="{ active: activeTab === 'market' }"
            @click="activeTab = 'market'"
            title="마켓"
          >
            <i class="ph-fill ph-storefront"></i>
          </button>
          <button 
            v-if="member_info.level >= 1"
            class="nav-tab" 
            :class="{ active: activeTab === 'admin' }"
            @click="activeTab = 'admin'; fetchFeedbackRequests();"
            title="관리"
          >
            <i class="ph-fill ph-clipboard-text"></i>
            <span v-if="pendingFeedbackCount > 0" class="nav-badge">{{ pendingFeedbackCount }}</span>
          </button>
        </div>

        <!-- 현재 페이지 타이틀 -->
        <div class="nav-title">
          <span class="title-label">{{ getCurrentTabLabel }}</span>
        </div>
      </div>

      <div class="nav-right">
        <button class="close-btn" @click="closeThisPage()">
          <i class="ph-bold ph-x"></i>
        </button>
      </div>
    </div>

    <dialog_solutionInfoEdit 
      v-if="showSolutionEdit" 
      :onOffFun="editSolution" 
      :reLoadFunction="fetchSolutions" 
      :solutionId="editingSolution.idx" 
    />

    <!-- ===================== -->
    <!-- 탭1: 내 작업 (Workspace) -->
    <!-- ===================== -->
    <Transition name="tab-slide" mode="out-in">
      <div class="container" v-if="activeTab === 'workspace'" key="workspace">
        
        <!-- Left Panel (메인 컨텐츠) -->
        <div class="left-panel">
          <!-- 툴바: 뷰토글 + 검색 + 정렬 -->
          <div class="panel-toolbar">
            <div class="view-toggle">
              <button 
                class="view-btn" 
                :class="{ active: workspaceView === 'customer' }"
                @click="workspaceView = 'customer'"
              >
                <i class="ph ph-users"></i>
                <span>고객</span>
                <span class="badge">{{ filteredCustomers.length }}</span>
              </button>
              <button 
                class="view-btn" 
                :class="{ active: workspaceView === 'library' }"
                @click="workspaceView = 'library'"
              >
                <i class="ph ph-folder-notch"></i>
                <span>내 플랜</span>
                <span class="badge">{{ plans.length }}</span>
              </button>
            </div>

            <div class="toolbar-controls">
              <!-- 검색 -->
              <div class="search-box" :class="{ focused: searchFocused }">
                <i class="ph ph-magnifying-glass"></i>
                <input 
                  v-if="workspaceView === 'customer'"
                  type="text" 
                  v-model="searchQuery"
                  placeholder="고객 검색..."
                  @focus="searchFocused = true"
                  @blur="searchFocused = false"
                >
                <input 
                  v-else
                  type="text" 
                  v-model="planSearchQuery"
                  placeholder="플랜 검색..."
                  @focus="searchFocused = true"
                  @blur="searchFocused = false"
                >
                <Transition name="fade">
                  <button 
                    v-if="workspaceView === 'customer' && searchQuery" 
                    class="clear-btn" 
                    @click="searchQuery = ''">
                    <i class="ph ph-x"></i>
                  </button>
                  <button 
                    v-else-if="workspaceView === 'library' && planSearchQuery" 
                    class="clear-btn" 
                    @click="planSearchQuery = ''">
                    <i class="ph ph-x"></i>
                  </button>
                </Transition>
              </div>

              <!-- 정렬 드롭다운 -->
              <div class="sort-dropdown">
                <button class="sort-btn" @click="showWorkspaceSort = !showWorkspaceSort">
                  <i class="ph ph-sort-ascending"></i>
                  <i class="ph ph-caret-down"></i>
                </button>
                <Transition name="dropdown">
                  <div v-if="showWorkspaceSort" class="dropdown-menu">
                    <button 
                      v-for="option in workspaceSortOptions" 
                      :key="option.value"
                      :class="{ active: workspaceSort === option.value }"
                      @click="workspaceSort = option.value; showWorkspaceSort = false"
                    >
                      <i :class="option.icon"></i>
                      {{ option.label }}
                    </button>
                  </div>
                </Transition>
              </div>
            </div>
          </div>

          <!-- 새 분석 버튼 -->
          <button v-if="workspaceView === 'customer'" class="add-btn" @click="showSolutionTypeSelector = true">
            <div class="add-btn-content">
              <div class="add-icon">
                <i class="ph-bold ph-plus"></i>
              </div>
              <div class="add-text">
                <span class="add-title">새 분석</span>
              </div>
            </div>
            <div class="add-arrow">
              <i class="ph ph-arrow-right"></i>
            </div>
          </button>

          <!-- 고객 뷰 -->
          <template v-if="workspaceView === 'customer'">
            <!-- Empty State -->
            <div v-if="filteredCustomers.length === 0 && !searchQuery" class="empty-state">
              <div class="empty-icon"><i class="ph ph-users"></i></div>
              <h3>아직 분석한 고객이 없습니다</h3>
              <p>위의 '새 분석' 버튼을 눌러 첫 번째 고객 분석을 시작해보세요</p>
            </div>

            <!-- No Search Results -->
            <div v-else-if="filteredCustomers.length === 0 && searchQuery" class="empty-state search">
              <div class="empty-icon"><i class="ph ph-magnifying-glass"></i></div>
              <h3>"{{ searchQuery }}" 검색 결과가 없습니다</h3>
              <p>다른 키워드로 검색해보세요</p>
            </div>
            
            <!-- 고객 아코디언 리스트 -->
            <TransitionGroup name="list" tag="div" class="customer-items">
              <template v-for="(customer, idx) in sortedCustomers" :key="customer.id">
                <div 
                  v-if="customer.solutions.length > 0"
                  class="customer-card"
                  :class="{ 
                    active: selectedCustomerId === customer.id,
                    unassigned: customer.isUnassigned
                  }"
                  :style="{ '--delay': `${idx * 0.05}s` }"
                >
                  <!-- 고객 헤더 (클릭하면 펼침/접힘) -->
                  <div class="customer-header" @click="toggleCustomer(customer.id)">
                    <div class="profile" :class="{ warning: customer.isUnassigned }">
                      <img :src="customer.profileImage || '/imgs/unknow_user.png'" :alt="customer.name" />
                      <div v-if="customer.isUnassigned" class="warning-badge">
                        <i class="ph-fill ph-warning"></i>
                      </div>
                    </div>
                    <div class="info">
                      <div class="name-row">
                        <span class="name">{{ customer.name }}</span>
                        <span v-if="!customer.isUnassigned" class="suffix">고객님</span>
                      </div>
                      <div class="sol-count">
                        <i class="ph ph-folder-open"></i>
                        솔루션 {{ customer.solutions.length }}개
                      </div>
                    </div>
                    <div class="expand-icon" :class="{ expanded: selectedCustomerId === customer.id }">
                      <i class="ph ph-caret-down"></i>
                    </div>
                  </div>

                  <!-- 솔루션 리스트 (펼쳐졌을 때) -->
                  <Transition name="expand">
                    <div v-if="selectedCustomerId === customer.id" class="solutions-wrapper">
                      <div 
                        v-for="solution in customer.solutions" 
                        :key="solution.idx"
                        class="solution-item"
                        :class="{ warning: solution.hasWarning }"
                      >
                        <div class="solution-main" @click="CA_openEdit(solution)">
                          <div class="solution-info">
                            <div class="chip-row">
                              <span class="chip">{{ solution.name }}</span>
                              <i v-if="solution.public" class="ph-fill ph-globe-hemisphere-west public-icon" title="공개중"></i>
                            </div>
                            <div class="meta">
                              <span class="date">
                                <i class="ph ph-calendar"></i>
                                {{ formatRelativeDate(solution.updated_at) }}
                              </span>
                              <span class="divider">•</span>
                              <span class="price">{{ formatMoney(solution.price) }}</span>
                            </div>
                          </div>
                        </div>
                        
                        <div class="solution-actions">
                          <button class="btn-icon share" @click.stop="toPubSolution(solution, !solution.public)" :title="solution.public ? '공개 해제' : '공개하기'">
                            <i :class="solution.public ? 'ph-fill ph-box-arrow-up' : 'ph ph-box-arrow-up'"></i>
                          </button>
                          <!-- <button class="btn-icon view" @click.stop="CA_openView(solution)" title="인쇄/보기">
                            <i class="ph ph-printer"></i>
                          </button> -->
                          <button class="btn-icon danger" @click.stop="confirmDelete(solution)" title="삭제">
                            <i class="ph ph-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>
              </template>
            </TransitionGroup>
          </template>

          <!-- 플랜 라이브러리 뷰 (그리드) -->
          <template v-if="workspaceView === 'library'">
            <div v-if="filteredPlans.length === 0 && !planSearchQuery" class="empty-state">
              <div class="empty-icon"><i class="ph ph-folder-open"></i></div>
              <h3>저장된 플랜이 없습니다</h3>
              <p>플랜 마켓에서 플랜을 가져오거나<br>솔루션에서 플랜을 만들어보세요</p>
            </div>

            <TransitionGroup v-else name="list" tag="div" class="plan-grid">
              <div 
                v-for="(plan, idx) in sortedPlans" 
                :key="plan.wr_id"
                class="plan-card"
                :class="{ active: selectedPlanId === plan.wr_id }"
                :style="{ '--delay': `${idx * 0.03}s` }"
                @click="selectPlan(plan)"
              >
                <div class="plan-card-header">
                  <div class="plan-company-logo">
                    <img :src="getInsuCompanyInfo(plan.company).short_img" :alt="getInsuCompanyInfo(plan.company).name">
                  </div>
                  <div class="plan-card-info">
                    <div class="plan-name">{{ plan.name }}</div>
                    <div class="plan-company">{{ getInsuCompanyInfo(plan.company).name }}</div>
                  </div>
                </div>
                <div class="plan-card-footer">
                  <span class="plan-price">{{ formatMoney(plan.price) }}</span>
                  <span class="plan-date">{{ plan.date }}</span>
                </div>
                <div class="plan-card-actions">
                  <button class="btn-mini" @click.stop="openPlanView(plan)" title="상세보기">
                    <i class="ph ph-eye"></i>
                  </button>
                  <button class="btn-mini danger" @click.stop="confirmDeletePlan(plan)" title="삭제">
                    <i class="ph ph-trash"></i>
                  </button>
                </div>
              </div>
            </TransitionGroup>
          </template>
        </div>

        <!-- Right Panel (요약 정보) -->
        <div class="right-panel">
          <div class="summary-header">
            <i class="ph-fill ph-info"></i>
            <span>요약</span>
          </div>

          <!-- 고객 뷰 요약 -->
          <template v-if="workspaceView === 'customer'">
            <div v-if="selectedCustomer" class="summary-content">
              <div class="summary-profile">
                <img :src="selectedCustomer.profileImage || '/imgs/unknow_user.png'" :alt="selectedCustomer.name" />
                <div class="summary-name">{{ selectedCustomer.name }}</div>
                <div class="summary-tag">{{ selectedCustomer.tag }}</div>
              </div>
              
              <div class="summary-stats">
                <div class="stat-item">
                  <span class="stat-value">{{ selectedCustomer.solutions.length }}</span>
                  <span class="stat-label">솔루션</span>
                </div>
                <div class="stat-item">
                  <span class="stat-value">{{ formatMoney(getTotalPrice(selectedCustomer)) }}</span>
                  <span class="stat-label">총 보험료</span>
                </div>
              </div>
            </div>
            <div v-else class="summary-empty">
              <i class="ph ph-user"></i>
              <p>고객을 선택하세요</p>
            </div>
          </template>

          <!-- 플랜 뷰 요약 -->
          <template v-if="workspaceView === 'library'">
            <div v-if="selectedPlanData" class="summary-content">
              <div class="summary-profile plan">
                <img :src="getInsuCompanyInfo(selectedPlanData.company).short_img" />
                <div class="summary-name">{{ selectedPlanData.name }}</div>
                <div class="summary-tag">{{ getInsuCompanyInfo(selectedPlanData.company).name }}</div>
              </div>
              
              <div class="summary-details">
                <div class="detail-row">
                  <span class="label">월 보험료</span>
                  <span class="value highlight">{{ formatMoney(selectedPlanData.price) }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">납입기간</span>
                  <span class="value">{{ selectedPlanData.pay || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">보장기간</span>
                  <span class="value">{{ selectedPlanData.end || '-' }}</span>
                </div>
              </div>

              <button class="summary-action-btn" @click="openPlanView(selectedPlanData)">
                <i class="ph ph-eye"></i>
                상세보기
              </button>
            </div>
            <div v-else class="summary-empty">
              <i class="ph ph-file-text"></i>
              <p>플랜을 선택하세요</p>
            </div>
          </template>
        </div>

      </div>

      <!-- ===================== -->
      <!-- 탭2: 마켓 -->
      <!-- ===================== -->
      <div class="container market-container" v-else-if="activeTab === 'market'" key="market">
        <div class="market-header">
          <div class="market-title-section">
            <h2>설계 마켓</h2>
            <p>다른 설계사들의 솔루션과 플랜을 참고해보세요</p>
          </div>
          <div class="market-stats">
            <div class="market-stat">
              <span class="value">{{ pub_solutions.length }}</span>
              <span class="label">공개 솔루션</span>
            </div>
            <div class="market-stat">
              <span class="value">{{ pub_plans.length }}</span>
              <span class="label">공개 플랜</span>
            </div>
          </div>
        </div>

        <div class="market-nav">
          <div class="category-tabs">
            <button 
              class="category-tab" 
              :class="{ active: marketCategory === 'solution' }"
              @click="marketCategory = 'solution'"
            >
              <i class="ph ph-chart-pie-slice"></i>
              <span>솔루션</span>
            </button>
            <button 
              class="category-tab" 
              :class="{ active: marketCategory === 'plan' }"
              @click="marketCategory = 'plan'"
            >
              <i class="ph ph-file-text"></i>
              <span>플랜</span>
            </button>
          </div>

          <div class="market-controls">
            <div 
              class="market-search" 
              :class="{ expanded: marketSearchFocused || marketSearchQuery, focused: marketSearchFocused }"
              @click="marketSearchFocused = true"
            >
              <i class="ph ph-magnifying-glass"></i>
              <input 
                type="text" 
                v-model="marketSearchQuery"
                placeholder="검색..."
                @focus="marketSearchFocused = true"
                @blur="marketSearchFocused = false"
              >
            </div>

            <div class="sort-wrapper">
              <button class="sort-btn" @click="showSortDropdown = !showSortDropdown">
                <i class="ph ph-sort-ascending"></i>
                <span>{{ getSortLabel(marketSort) }}</span>
                <i class="ph ph-caret-down"></i>
              </button>
              <Transition name="dropdown">
                <div v-if="showSortDropdown" class="dropdown-menu">
                  <button 
                    v-for="option in sortOptions" 
                    :key="option.value"
                    :class="{ active: marketSort === option.value }"
                    @click="marketSort = option.value; showSortDropdown = false"
                  >
                    <i :class="option.icon"></i>
                    {{ option.label }}
                  </button>
                </div>
              </Transition>
            </div>
          </div>
        </div>

        <div class="market-content">
          <!-- 솔루션 마켓 -->
          <template v-if="marketCategory === 'solution'">
            <div v-if="filteredMarketSolutions.length === 0" class="empty-state">
              <div class="empty-icon"><i class="ph ph-storefront"></i></div>
              <h3>공개된 솔루션이 없습니다</h3>
              <p>다른 설계사들이 솔루션을 공개하면 여기에 표시됩니다</p>
            </div>

            <div v-else class="grid-items">
              <div 
                v-for="sol in filteredMarketSolutions" 
                :key="sol.idx"
                class="market-card"
              >
                <div class="market-card-header">
                  <div class="card-logo">
                    <i class="ph-fill ph-chart-pie-slice"></i>
                  </div>
                  <div class="card-info">
                    <div class="card-title">{{ sol.name }}</div>
                    <div class="card-subtitle">{{ sol.author_name || sol.mb_id }}</div>
                  </div>
                </div>
                <div class="market-card-body">
                  <div class="card-meta">
                    <span class="meta-item">
                      <i class="ph ph-calendar"></i>
                      {{ formatRelativeDate(sol.updated_at) }}
                    </span>
                  </div>
                </div>
                <div class="market-card-footer">
                  <span class="card-price">{{ formatMoney(sol.price) }}</span>
                  <div class="card-actions">
                    <button class="action-btn primary" @click="downloadSolution(sol)">
                      <i class="ph ph-download-simple"></i>
                      가져오기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 플랜 마켓 -->
          <template v-if="marketCategory === 'plan'">
            <!-- 보험사 필터 -->
            <div v-if="popularCompanies.length > 0" class="company-filter">
              <button 
                class="company-chip" 
                :class="{ active: !marketFilter.company }"
                @click="marketFilter.company = ''"
              >
                전체
              </button>
              <button 
                v-for="company in popularCompanies" 
                :key="company.idx"
                class="company-chip"
                :class="{ active: marketFilter.company === company.idx }"
                @click="marketFilter.company = company.idx"
              >
                <img :src="company.short_img" :alt="company.name">
                {{ company.name }}
              </button>
            </div>

            <div v-if="filteredMarketPlans.length === 0" class="empty-state">
              <div class="empty-icon"><i class="ph ph-storefront"></i></div>
              <h3>공개된 플랜이 없습니다</h3>
              <p>다른 설계사들이 플랜을 공개하면 여기에 표시됩니다</p>
            </div>

            <div v-else class="grid-items">
              <div 
                v-for="plan in filteredMarketPlans" 
                :key="plan.wr_id"
                class="market-card"
              >
                <div class="market-card-header">
                  <div class="card-logo">
                    <img :src="getInsuCompanyInfo(plan.company).short_img" :alt="getInsuCompanyInfo(plan.company).name">
                  </div>
                  <div class="card-info">
                    <div class="card-title">{{ plan.name }}</div>
                    <div class="card-subtitle">{{ getInsuCompanyInfo(plan.company).name }}</div>
                  </div>
                </div>
                <div class="market-card-body">
                  <div class="card-meta">
                    <span class="meta-item">
                      <i class="ph ph-calendar-blank"></i>
                      {{ plan.pay || '-' }}
                    </span>
                    <span class="meta-item">
                      <i class="ph ph-shield-check"></i>
                      {{ plan.end || '-' }}
                    </span>
                  </div>
                </div>
                <div class="market-card-footer">
                  <span class="card-price">{{ formatMoney(plan.price) }}</span>
                  <div class="card-actions">
                    <button class="action-btn primary" @click="downloadPlan(plan)">
                      <i class="ph ph-download-simple"></i>
                      가져오기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- ===================== -->
      <!-- 탭3: 관리 (Admin) -->
      <!-- ===================== -->
      <div class="container admin-container" v-else-if="activeTab === 'admin'" key="admin">
        <div class="admin-header">
          <div class="admin-title-section">
            <h2>피드백 관리</h2>
            <p>요청된 피드백을 검토하고 응답하세요</p>
          </div>
          <div class="admin-stats">
            <div class="admin-stat pending">
              <i class="ph-fill ph-clock"></i>
              <span class="value">{{ pendingFeedbackCount }}</span>
              <span class="label">대기중</span>
            </div>
            <div class="admin-stat complete">
              <i class="ph-fill ph-check-circle"></i>
              <span class="value">{{ completedFeedbackCount }}</span>
              <span class="label">완료</span>
            </div>
          </div>
        </div>

        <div class="admin-filter">
          <button 
            class="filter-btn" 
            :class="{ active: feedbackFilter === 'all' }"
            @click="feedbackFilter = 'all'"
          >
            전체
          </button>
          <button 
            class="filter-btn" 
            :class="{ active: feedbackFilter === 'requested' }"
            @click="feedbackFilter = 'requested'"
          >
            대기중
          </button>
          <button 
            class="filter-btn" 
            :class="{ active: feedbackFilter === 'in_progress' }"
            @click="feedbackFilter = 'in_progress'"
          >
            검토중
          </button>
          <button 
            class="filter-btn" 
            :class="{ active: feedbackFilter === 'complete' }"
            @click="feedbackFilter = 'complete'"
          >
            완료
          </button>
        </div>

        <div class="admin-content">
          <div v-if="filteredFeedbackRequests.length === 0" class="empty-state">
            <div class="empty-icon"><i class="ph ph-clipboard-text"></i></div>
            <h3>피드백 요청이 없습니다</h3>
            <p>새로운 피드백 요청이 들어오면 여기에 표시됩니다</p>
          </div>

          <div v-else class="request-list">
            <div 
              v-for="request in filteredFeedbackRequests" 
              :key="request.idx"
              class="request-item"
            >
              <div class="request-avatar">
                <i class="ph ph-user"></i>
              </div>
              <div class="request-info">
                <div class="request-title">{{ request.solution_name || `솔루션 #${request.solution_idx}` }}</div>
                <div class="request-meta">
                  <span>{{ request.requester_id }}</span>
                  <span class="request-status" :class="request.status">
                    {{ getFilterLabel(request.status) }}
                  </span>
                </div>
              </div>
              <div class="request-actions">
                <button 
                  v-if="request.status === 'requested'" 
                  class="action-btn primary"
                  @click="startReview(request)"
                >
                  <i class="ph ph-play"></i>
                  검토 시작
                </button>
                <button 
                  v-else-if="request.status === 'in_progress'" 
                  class="action-btn"
                  @click="continueReview(request)"
                >
                  <i class="ph ph-pencil"></i>
                  계속하기
                </button>
                <button 
                  v-else-if="request.status === 'complete'" 
                  class="action-btn"
                  @click="viewCompletedReview(request)"
                >
                  <i class="ph ph-eye"></i>
                  보기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>

  </div>
</template>

<script>
import { inject, onMounted, ref, computed } from "vue";
import dialog_solutionInfoEdit from '@/components/dialogs/solutionInfoEdit.vue';
import dialog_customerRegister from '@/components/dialogs/customerRegister.vue';
import dialog_customerPicker from '@/components/dialogs/customerPicker.vue';
import { useBackButton } from '@/utils/useBackBtn';
import dialog_caEdit from '@/components/dialogs/caEdit.vue';
import dialog_caView from '@/components/dialogs/caView.vue';
import dialog_planView from '@/components/dialogs/caPlanView.vue';

export default {
  components: {
    dialog_solutionInfoEdit,
    dialog_customerPicker,
    dialog_customerRegister,
    dialog_caEdit,
    dialog_caView,
    dialog_planView,
  },
  props: {
    oth_showCALibrary: Function,
  },
  setup(props) {

    useBackButton(() => {
      closeThisPage();
    });

    // 탭 상태
    const activeTab = ref('workspace');
    const workspaceView = ref('customer');
    
    // 검색 상태
    const searchQuery = ref('');
    const searchFocused = ref(false);
    const planSearchQuery = ref('');
    const planSearchFocused = ref(false);
    
    // 정렬 상태
    const showWorkspaceSort = ref(false);
    const workspaceSort = ref('latest');
    const workspaceSortOptions = [
      { value: 'latest', label: '최신순', icon: 'ph ph-clock' },
      { value: 'name', label: '이름순', icon: 'ph ph-sort-ascending' },
      { value: 'solutions', label: '솔루션 많은순', icon: 'ph ph-folder-notch' },
    ];

    // 마켓 상태
    const marketCategory = ref('solution');
    const marketSort = ref('latest');
    const marketSearchQuery = ref('');
    const marketSearchFocused = ref(false);
    const showSortDropdown = ref(false);
    const marketFilter = ref({ company: '' });

    const sortOptions = [
      { value: 'latest', label: '최신순', icon: 'ph ph-clock' },
      { value: 'popular', label: '인기순', icon: 'ph ph-fire' },
      { value: 'price_low', label: '가격 낮은순', icon: 'ph ph-sort-ascending' },
      { value: 'price_high', label: '가격 높은순', icon: 'ph ph-sort-descending' },
    ];

    function getSortLabel(value) {
      return sortOptions.find(o => o.value === value)?.label || '정렬';
    }
    
    // 기타 상태
    const editingSolution = ref(null);
    const showSolutionEdit = ref(false);
    const customers = ref([]);
    const solutions = ref([]);
    const plans = ref([]);
    const pub_plans = ref([]);
    const pub_solutions = ref([]);
    const loading = ref(false);
    const loadPrg = ref(0);
    const laodMax = ref(100);
    const selectedSolution = ref(null);
    const useViewDialog = ref(false);
    const useEditDialog = ref(false);
    const selectedCustomerId = ref(null);
    const selectedPlanId = ref(null);
    const loadingMent = ref('다운로드 중...');
    const showCustomerRegister = ref(false);
    const showPlanView = ref(false);
    const selectedPlanIdx = ref(null);
    const showSolutionTypeSelector = ref(false);
    const showCustomerPicker = ref(false);
    
    // 관리 탭 관련
    const feedbackRequests = ref([]);
    const feedbackFilter = ref('all');
    const pendingFeedbackCount = ref(0);
    const completedFeedbackCount = ref(0);
    
    // Toast
    const toast = ref({
      show: false,
      message: '',
      type: 'success',
      icon: 'ph-check-circle'
    });

    const calculateInsuAge = inject('calculateInsuAge');
    const member_info = inject('member_info');
    const sql_query = inject('sql_query');
    const getInsuCompanyInfo = inject('getInsuCompanyInfo');

    // 현재 탭 라벨
    const getCurrentTabLabel = computed(() => {
      switch (activeTab.value) {
        case 'workspace': return '보장 스케치';
        case 'market': return '설계 마켓';
        case 'admin': return '피드백 관리';
        default: return '보장 스케치';
      }
    });

    // 고객 토글 (아코디언)
    function toggleCustomer(customerId) {
      if (selectedCustomerId.value === customerId) {
        selectedCustomerId.value = null;
      } else {
        selectedCustomerId.value = customerId;
      }
    }

    // 총 보험료 계산
    function getTotalPrice(customer) {
      if (!customer || !customer.solutions) return 0;
      return customer.solutions.reduce((sum, sol) => sum + (parseFloat(sol.price) || 0), 0);
    }

    // 정렬된 고객 목록
    const sortedCustomers = computed(() => {
      let result = [...filteredCustomers.value];
      switch (workspaceSort.value) {
        case 'latest':
          result.sort((a, b) => {
            const aLatest = Math.max(...a.solutions.map(s => new Date(s.updated_at)));
            const bLatest = Math.max(...b.solutions.map(s => new Date(s.updated_at)));
            return bLatest - aLatest;
          });
          break;
        case 'name':
          result.sort((a, b) => a.name.localeCompare(b.name, 'ko'));
          break;
        case 'solutions':
          result.sort((a, b) => b.solutions.length - a.solutions.length);
          break;
      }
      return result;
    });

    // 정렬된 플랜 목록
    const sortedPlans = computed(() => {
      let result = [...filteredPlans.value];
      switch (workspaceSort.value) {
        case 'latest':
          result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          break;
        case 'name':
          result.sort((a, b) => a.name.localeCompare(b.name, 'ko'));
          break;
        default:
          result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      }
      return result;
    });

    // 마켓 관련 computed
    const popularCompanies = computed(() => {
      const companyMap = new Map();
      pub_plans.value.forEach(plan => {
        const info = getInsuCompanyInfo(plan.company);
        if (info && info.idx) {
          if (!companyMap.has(info.idx)) {
            companyMap.set(info.idx, { ...info, count: 0 });
          }
          companyMap.get(info.idx).count++;
        }
      });
      return Array.from(companyMap.values()).sort((a, b) => b.count - a.count).slice(0, 6);
    });

    const filteredMarketSolutions = computed(() => {
      let result = [...pub_solutions.value];
      if (marketSearchQuery.value) {
        const q = marketSearchQuery.value.toLowerCase();
        result = result.filter(s => 
          s.name?.toLowerCase().includes(q) ||
          s.author_name?.toLowerCase().includes(q) ||
          s.mb_id?.toLowerCase().includes(q)
        );
      }
      switch (marketSort.value) {
        case 'latest':
          result.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
          break;
        case 'popular':
          result.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
          break;
        case 'price_low':
          result.sort((a, b) => (a.price || 0) - (b.price || 0));
          break;
        case 'price_high':
          result.sort((a, b) => (b.price || 0) - (a.price || 0));
          break;
      }
      return result;
    });

    const filteredMarketPlans = computed(() => {
      let result = [...pub_plans.value];
      if (marketFilter.value.company) {
        result = result.filter(p => {
          const info = getInsuCompanyInfo(p.company);
          return info?.idx === marketFilter.value.company;
        });
      }
      if (marketSearchQuery.value) {
        const q = marketSearchQuery.value.toLowerCase();
        result = result.filter(p => 
          p.name?.toLowerCase().includes(q) ||
          getInsuCompanyInfo(p.company)?.name?.toLowerCase().includes(q)
        );
      }
      switch (marketSort.value) {
        case 'latest':
          result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          break;
        case 'popular':
          result.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          break;
        case 'price_low':
          result.sort((a, b) => (a.price || 0) - (b.price || 0));
          break;
        case 'price_high':
          result.sort((a, b) => (b.price || 0) - (a.price || 0));
          break;
      }
      return result;
    });

    function showToast(message, type = 'success') {
      const icons = {
        success: 'ph-fill ph-check-circle',
        error: 'ph-fill ph-x-circle',
        warning: 'ph-fill ph-warning-circle',
        info: 'ph-fill ph-info'
      };
      toast.value = { show: true, message, type, icon: icons[type] };
      setTimeout(() => { toast.value.show = false; }, 3000);
    }

    function CA_openView(solution) {
      selectedSolution.value = solution;
      viewDialogOnOff(true);
    }

    function viewDialogOnOff(b) {
      useViewDialog.value = b;
    }

    function CA_openEdit(solution) {
      selectedSolution.value = solution;
      editDialogOnOff(true);
    }

    function editDialogOnOff(b) {
      useEditDialog.value = b;
    }
    
    function customerRegisterSwitch(b) {
      showCustomerRegister.value = b;
    }

    function openCustomerRegister() {
      showSolutionTypeSelector.value = false;
      showCustomerRegister.value = true;
    }

    function openPlanView(plan) {
      selectedPlanIdx.value = plan.wr_id;
      showPlanView.value = true;
    }

    function closePlanView() {
      showPlanView.value = false;
      selectedPlanIdx.value = null;
    }

    function selectPlan(plan) {
      selectedPlanId.value = plan.wr_id;
    }

    const selectedPlanData = computed(() => {
      if (!selectedPlanId.value) return null;
      return plans.value.find(p => p.wr_id === selectedPlanId.value);
    });

    const filteredPlans = computed(() => {
      if (!planSearchQuery.value) return plans.value;
      const query = planSearchQuery.value.toLowerCase();
      return plans.value.filter(plan => 
        plan.name.toLowerCase().includes(query) ||
        getInsuCompanyInfo(plan.company).name.toLowerCase().includes(query)
      );
    });

    const filteredFeedbackRequests = computed(() => {
      if (feedbackFilter.value === 'all') return feedbackRequests.value;
      return feedbackRequests.value.filter(r => r.status === feedbackFilter.value);
    });

    const customersWithData = computed(() => {
      const result = customers.value.map(customer => {
        const customerSolutions = solutions.value.filter(solution => solution.customer_idx === customer.idx);
        const solutionIds = customerSolutions.map(s => s.idx);
        const customerPlans = plans.value.filter(plan => solutionIds.includes(plan.solution_id));
        let tagText = '태그 없음';
        if (customer.tags && customer.tags.length > 0) {
          tagText = customer.tags.join(', ');
        }
        return {
          id: customer.idx,
          name: customer.name,
          profileImage: '/imgs/unknow_user.png',
          tag: tagText,
          birth: customer.birth,
          sex: customer.sex,
          phone: customer.phone,
          isUnassigned: false,
          solutions: customerSolutions.map(sol => ({
            idx: sol.idx,
            name: sol.name,
            price: sol.price_manual == 0 ? sol.price : getSolutionPrice(sol),
            status: sol.status,
            created_at: sol.created_at,
            updated_at: sol.updated_at,
            type: sol.type,
            customer_idx: sol.customer_idx,
            feedback_status: sol.feedback_status || 'none',
            public: sol.public || 0,
          })),
          plans: customerPlans.map(plan => ({
            wr_id: plan.wr_id,
            name: plan.name,
            company: plan.company,
            price: plan.price,
            date: plan.date
          }))
        };
      });

      const customerIds = customers.value.map(c => c.idx);
      const unassignedSolutions = solutions.value.filter(solution => 
        !solution.customer_idx || solution.customer_idx === 0 || !customerIds.includes(solution.customer_idx)
      );

      if (unassignedSolutions.length > 0) {
        result.unshift({
          id: 0,
          name: '미지정 솔루션',
          profileImage: 'https://cdn-icons-png.flaticon.com/512/8199/8199110.png',
          tag: '고객 연결 필요',
          birth: null,
          sex: 0,
          phone: null,
          isUnassigned: true,
          solutions: unassignedSolutions.map(sol => ({
            idx: sol.idx,
            name: sol.name,
            price: sol.price_manual == 0 ? sol.price : getSolutionPrice(sol),
            status: sol.status,
            created_at: sol.created_at,
            updated_at: sol.updated_at,
            hasWarning: true,
            type: sol.type,
            customer_idx: sol.customer_idx,
            feedback_status: sol.feedback_status || 'none',
            public: sol.public || 0,
          })),
          plans: []
        });
      }
      return result;
    });

    const selectedCustomer = computed(() => {
      if (!selectedCustomerId.value) return null;
      return customersWithData.value.find(c => c.id === selectedCustomerId.value);
    });

    const filteredCustomers = computed(() => {
      if (!searchQuery.value) return customersWithData.value;
      const query = searchQuery.value.toLowerCase();
      return customersWithData.value.filter(customer => 
        customer.name.toLowerCase().includes(query) || customer.tag.toLowerCase().includes(query)
      );
    });

    function selectCustomer(customerId) {
      selectedCustomerId.value = customerId;
    }

    function genderChoser(code) {
      if (!code || code == 0) return '무성';
      return code % 2 === 0 ? '여성' : '남성';
    }

    function getSolStatus(int) {
      const statusMap = { 0: "임시", 1: "스케치", 2: "보장분석", 3: "보장제안", 4: "임시보기", 5: "상담 중", 6: "계약 완료", 7: "계약 관리" };
      return statusMap[int] || "없음";
    }

    async function fetchCustomers() {
      const sql = `SELECT * FROM customers WHERE mb_id = '${member_info.mb_id}' ORDER BY last_touch DESC`;
      const result = await sql_query(sql);
      customers.value = (result || []).map(row => ({
        idx: row.idx, mb_id: row.mb_id, name: row.name, nickname: row.nickname, title: row.title,
        birth: row.birth, sex: row.sex, phone: row.phone, job: row.job, address: row.address,
        tags: row.tags ? JSON.parse(row.tags) : [], notes: row.notes, created_at: row.created_at, last_touch: row.last_touch
      }));
      if (customers.value.length > 0 && !selectedCustomerId.value) {
        selectedCustomerId.value = customers.value[0].idx;
      }
    }

    async function fetchSolutions() {
      const sql = `SELECT * FROM IS_solution WHERE mb_id = '${member_info.mb_id}' ORDER BY updated_at DESC`;
      const result = await sql_query(sql);
      solutions.value = (result || []).map(row => ({
        idx: row.idx, name: row.name, client: typeof row.client === 'string' ? JSON.parse(row.client) : row.client,
        customer_idx: row.customer_idx, created_at: (row.created_at || '').slice(0, 10), updated_at: row.updated_at,
        status: row.status, price: row.price, price_manual: row.price_manual || 0, purpose: row.purpose || '',
        mb_id: row.mb_id, rate: row.rate || 0, type: row.type, feedback_status: row.feedback_status || 'none', public: row.public || 0,
      }));
    }

    async function fetchPlans() {
      const sql = `SELECT * FROM IS_plan WHERE mb_id = '${member_info.mb_id}' AND fav = '1' ORDER BY idx DESC`;
      const result = await sql_query(sql);
      plans.value = (result || []).map(row => ({
        wr_id: row.idx, name: row.name, mb_id: row.mb_id, company: row.company, number: row.number,
        pay: row.pay, end: row.end, price: row.price, solution_id: row.solution_id, created_at: row.created_at,
        date: (row.created_at || '').split("T")[0], type: row.type, sub_type: row.sub_type,
      }));
      if (plans.value.length > 0 && !selectedPlanId.value) {
        selectedPlanId.value = plans.value[0].wr_id;
      }
    }

    async function fetchPubPlans() {
      const sql = `SELECT * FROM IS_plan WHERE public = '1' ORDER BY idx DESC LIMIT 0, 30`;
      const result = await sql_query(sql);
      pub_plans.value = (result || []).map(row => ({
        wr_id: row.idx, mb_id: row.mb_id, name: row.name, company: row.company, number: row.number,
        pay: row.pay, end: row.end, price: row.price, solution_id: row.solution_id, created_at: row.created_at,
        type: row.type, sub_type: row.sub_type,
      }));
    }

    async function fetchPubSolutions() {
      try {
        const sql = `SELECT s.*, m.name as author_name FROM IS_solution s LEFT JOIN member m ON s.mb_id = m.mb_id WHERE s.public = '1' ORDER BY s.updated_at DESC LIMIT 30`;
        const result = await sql_query(sql);
        pub_solutions.value = Array.isArray(result) ? result : [];
      } catch (error) {
        console.error('공개 솔루션 조회 실패:', error);
        pub_solutions.value = [];
      }
    }

    async function toPubSolution(solution, toPublic) {
      const comment = toPublic ? "솔루션을 공개하시겠습니까?\n(플랜과 보장내역이 함께 공개됩니다)" : "공개를 취소하시겠습니까?";
      if (!confirm(comment)) return;
      try {
        await sql_query(`UPDATE IS_solution SET public = '${toPublic ? 1 : 0}' WHERE idx = ${solution.idx}`);
        showToast(toPublic ? '솔루션이 공개되었습니다' : '공개가 해제되었습니다', 'success');
        fetchPubSolutions();
        fetchSolutions();
      } catch (error) {
        console.error('솔루션 공개 중 오류:', error);
        showToast('오류가 발생했습니다', 'error');
      }
    }

    async function downloadSolution(sol) {
      if (!confirm(`"${sol.name}" 솔루션을 내 라이브러리에 복사하시겠습니까?`)) return;
      loading.value = true;
      loadingMent.value = '솔루션 복사 중...';
      loadPrg.value = 0;
      try {
        const origSolution = await sql_query(`SELECT * FROM IS_solution WHERE idx = ${sol.idx}`);
        if (!origSolution || origSolution.length === 0) throw new Error('솔루션을 찾을 수 없습니다');
        const orig = origSolution[0];
        const clientJson = (typeof orig.client === 'string' ? orig.client : JSON.stringify(orig.client || {})).replace(/'/g, "\\'");
        const solutionSql = `INSERT INTO IS_solution (name, type, client, customer_idx, mb_id, price, price_manual, tags, memo, purpose, status, public, rate, rate_public, rate_mento, feedback_status) VALUES ('${(orig.name || '').replace(/'/g, "\\'")} (복사본)', ${orig.type || 0}, '${clientJson}', 0, '${member_info.mb_id}', '${orig.price || 0}', ${orig.price_manual || 0}, '${(orig.tags || '').replace(/'/g, "\\'")}', '${(orig.memo || '').replace(/'/g, "\\'")}', '${(orig.purpose || '').replace(/'/g, "\\'")}', ${orig.status || 1}, 0, 0, 0, 0, 'none')`;
        const solResult = await sql_query(solutionSql);
        const newSolutionIdx = solResult.insertId;
        loadPrg.value = 1;
        const origPlans = await sql_query(`SELECT * FROM IS_plan WHERE solution_id = ${sol.idx} ORDER BY number ASC`);
        laodMax.value = 2 + (origPlans?.length || 0);
        for (const plan of (origPlans || [])) {
          const planSql = `INSERT INTO IS_plan (mb_id, solution_id, number, name, type, type_id, sub_type, company, company_etc, pay, pay_type, end, end_type, price, joined_at, status, public, fav, origin_id, renewable, rate, rate_public, rate_mento, remarks, worth, return_worth) VALUES ('${member_info.mb_id}', ${newSolutionIdx}, ${plan.number || 0}, '${(plan.name || '').replace(/'/g, "\\'")}', '${(plan.type || '').replace(/'/g, "\\'")}', ${plan.type_id || 0}, '${(plan.sub_type || '').replace(/'/g, "\\'")}', '${(plan.company || '').replace(/'/g, "\\'")}', '${(plan.company_etc || '').replace(/'/g, "\\'")}', '${(plan.pay || '').replace(/'/g, "\\'")}', '${(plan.pay_type || '').replace(/'/g, "\\'")}', '${(plan.end || '').replace(/'/g, "\\'")}', '${(plan.end_type || '').replace(/'/g, "\\'")}', '${plan.price || 0}', ${plan.joined_at ? `'${plan.joined_at}'` : 'NULL'}, ${plan.status || 1}, 0, 0, NULL, ${plan.renewable || 0}, ${plan.rate || 0}, ${plan.rate_public || 0}, ${plan.rate_mento || 0}, '${(plan.remarks || '').replace(/'/g, "\\'")}', ${plan.worth || 0}, ${plan.return_worth || 0})`;
          const planResult = await sql_query(planSql);
          const newPlanIdx = planResult.insertId;
          const origCoverages = await sql_query(`SELECT * FROM IS_coverage WHERE plan_id = ${plan.idx} ORDER BY parent IS NULL DESC, idx ASC`);
          const idMap = {};
          for (const cov of (origCoverages || [])) {
            const newParent = cov.parent ? (idMap[cov.parent] || null) : null;
            const covSql = `INSERT INTO IS_coverage (original, plan_id, nick, value, visible, calculable, benefit_type, period_value, period_type, renewable, premium, chapter_id, parent, is_union, style_bold, style_important) VALUES (${cov.original || 'NULL'}, ${newPlanIdx}, ${cov.nick ? `'${cov.nick.replace(/'/g, "\\'")}'` : 'NULL'}, ${cov.value ? `'${cov.value}'` : 'NULL'}, ${cov.visible || 0}, ${cov.calculable || 0}, ${cov.benefit_type ? `'${cov.benefit_type}'` : 'NULL'}, ${cov.period_value || 'NULL'}, ${cov.period_type ? `'${cov.period_type}'` : 'NULL'}, ${cov.renewable || 0}, ${cov.premium || 0}, ${cov.chapter_id || 'NULL'}, ${newParent || 'NULL'}, ${cov.is_union || 0}, ${cov.style_bold || 0}, ${cov.style_important || 0})`;
            const covResult = await sql_query(covSql);
            idMap[cov.idx] = covResult.insertId;
          }
          loadPrg.value++;
        }
        await fetchSolutions();
        loading.value = false;
        showToast('솔루션이 라이브러리에 추가되었습니다', 'success');
      } catch (error) {
        console.error('솔루션 복사 중 오류:', error);
        loading.value = false;
        showToast('솔루션 복사 중 오류가 발생했습니다', 'error');
      }
    }

    async function fetchFeedbackRequests() {
      try {
        const sql = `SELECT * FROM IS_solution_feedback ORDER BY requested_at DESC`;
        const result = await sql_query(sql);
        feedbackRequests.value = Array.isArray(result) ? result : [];
        pendingFeedbackCount.value = feedbackRequests.value.filter(r => r.status === 'requested').length;
        completedFeedbackCount.value = feedbackRequests.value.filter(r => r.status === 'complete').length;
      } catch (error) {
        console.error('피드백 목록 조회 실패:', error);
        feedbackRequests.value = [];
        pendingFeedbackCount.value = 0;
        completedFeedbackCount.value = 0;
      }
    }

    function getFilterLabel(filter) {
      const labels = { 'requested': '대기중', 'in_progress': '검토중', 'complete': '완료' };
      return labels[filter] || filter;
    }

    async function startReview(request) {
      await sql_query(`UPDATE IS_solution_feedback SET status = 'in_progress', reviewer_id = '${member_info.mb_id}', started_at = NOW() WHERE idx = ${request.idx}`);
      const solResult = await sql_query(`SELECT * FROM IS_solution WHERE idx = ${request.solution_idx}`);
      if (solResult.length > 0) {
        const solution = { idx: solResult[0].idx, name: solResult[0].name, client: JSON.parse(solResult[0].client), customer_idx: solResult[0].customer_idx, created_at: solResult[0].created_at, updated_at: solResult[0].updated_at, status: solResult[0].status, price: solResult[0].price, type: solResult[0].type, feedback_idx: request.idx, feedback_mode: true };
        selectedSolution.value = solution;
        viewDialogOnOff(true);
      }
      fetchFeedbackRequests();
    }

    async function continueReview(request) {
      const solResult = await sql_query(`SELECT * FROM IS_solution WHERE idx = ${request.solution_idx}`);
      if (solResult.length > 0) {
        const solution = { idx: solResult[0].idx, name: solResult[0].name, client: JSON.parse(solResult[0].client), customer_idx: solResult[0].customer_idx, created_at: solResult[0].created_at, updated_at: solResult[0].updated_at, status: solResult[0].status, price: solResult[0].price, type: solResult[0].type, feedback_idx: request.idx, feedback_mode: true, existing_annotations: request.annotations ? JSON.parse(request.annotations) : [] };
        selectedSolution.value = solution;
        viewDialogOnOff(true);
      }
    }

    async function viewCompletedReview(request) {
      const solResult = await sql_query(`SELECT * FROM IS_solution WHERE idx = ${request.solution_idx}`);
      if (solResult.length > 0) {
        const solution = { idx: solResult[0].idx, name: solResult[0].name, client: JSON.parse(solResult[0].client), customer_idx: solResult[0].customer_idx, created_at: solResult[0].created_at, updated_at: solResult[0].updated_at, status: solResult[0].status, price: solResult[0].price, type: solResult[0].type, feedback_idx: request.idx, feedback_mode: 'view', annotations: request.annotations ? JSON.parse(request.annotations) : [], comment: request.comment };
        selectedSolution.value = solution;
        viewDialogOnOff(true);
      }
    }

    onMounted(() => {
      fetchCustomers();
      fetchSolutions();
      fetchPlans();
      fetchPubPlans();
      fetchPubSolutions();
      if (member_info.level >= 1) fetchFeedbackRequests();
    });

    function selectVirtual() {
      showSolutionTypeSelector.value = false;
      makeSolution(0);
    }

    function openCustomerPicker() {
      showSolutionTypeSelector.value = false;
      showCustomerPicker.value = true;
    }

    function handleCustomerSelect(result) {
      showCustomerPicker.value = false;
      if (result.customer) makeSolution(result.customer.idx);
    }

    async function makeSolution(customerIdx) {
      try {
        let base_cli_info = { "job": "없음", "sex": "남", "c_id": customerIdx || 0, "name": "홍길동", "civ_code": "123456-1234567", "personal": "미검사" };
        let client_json = JSON.stringify(base_cli_info).replace(/'/g, "\\'");
        let res = await sql_query(`INSERT INTO IS_solution SET mb_id = '${member_info.mb_id}', name = '새솔루션', client = '${client_json}', created_at = NOW(), status = '1', price = 0, customer_idx = '${customerIdx || 0}'`);
        const insertId = res.insertId;
        await fetchSolutions();
        const newSolution = solutions.value.find(solution => solution.idx === insertId);
        if (newSolution) {
          showToast('새 솔루션이 생성되었습니다', 'success');
          CA_openEdit(newSolution);
        }
      } catch (error) {
        console.error('새 솔루션 생성 중 오류:', error);
        showToast('솔루션 생성 중 오류가 발생했습니다', 'error');
      }
    }

    async function confirmDelete(solution) {
      if (!confirm(`"${solution.name}" 솔루션을 삭제하시겠습니까?`)) return;
      await deleteSolution(solution);
    }

    async function deleteSolution(solution) {
      try {
        await sql_query(`DELETE FROM IS_solution WHERE idx = ${solution.idx}`);
        showToast('솔루션이 삭제되었습니다', 'success');
        fetchSolutions();
      } catch (error) {
        showToast('삭제 중 오류가 발생했습니다', 'error');
      }
    }

    async function confirmDeletePlan(plan) {
      if (!confirm(`"${plan.name}" 플랜을 삭제하시겠습니까?`)) return;
      await deletePlan(plan);
    }

    async function deletePlan(plan) {
      try {
        await sql_query(`DELETE FROM IS_plan WHERE idx = ${plan.wr_id}`);
        showToast('플랜이 삭제되었습니다', 'success');
        selectedPlanId.value = null;
        fetchPlans();
      } catch (error) {
        showToast('삭제 중 오류가 발생했습니다', 'error');
      }
    }

    async function toPubPlan(plan, b) {
      const comment = b ? "플랜을 공개하시겠습니까?" : "공개를 취소하시겠습니까?";
      if (!confirm(comment)) return;
      try {
        await sql_query(`UPDATE IS_plan SET public = '${b ? 1 : 0}' WHERE idx = ${plan.wr_id}`);
        showToast(b ? '플랜이 공개되었습니다' : '공개가 해제되었습니다', 'success');
        fetchPubPlans();
      } catch (error) {
        console.error('플랜 공개 중 오류:', error);
        showToast('오류가 발생했습니다', 'error');
      }
    }

    async function downloadPlan(plan) {
      loading.value = true;
      loadingMent.value = '플랜을 라이브러리에 추가하는 중...';
      loadPrg.value = 0;
      const sql = `INSERT INTO IS_plan (mb_id, solution_id, number, name, type, type_id, sub_type, company, company_etc, pay, pay_type, end, end_type, price, joined_at, created_at, updated_at, status, public, fav, origin_id, renewable, rate, rate_public, rate_mento, remarks, worth, return_worth) SELECT '${member_info.mb_id}', 0, number, name, type, type_id, sub_type, company, company_etc, pay, pay_type, end, end_type, price, joined_at, NOW(), NOW(), status, 0, 1, idx, renewable, rate, rate_public, rate_mento, remarks, worth, return_worth FROM IS_plan WHERE idx = ${plan.wr_id}`;
      try {
        const result = await sql_query(sql);
        const getCoverages = `SELECT * FROM IS_coverage WHERE plan_id = ${plan.wr_id} ORDER BY parent IS NULL DESC, idx ASC`;
        const coverages = await sql_query(getCoverages);
        laodMax.value = coverages.length;
        const idMap = {};
        for (const coverage of coverages) {
          const newParent = coverage.parent ? (idMap[coverage.parent] || null) : null;
          const insertSql = `INSERT INTO IS_coverage (original, plan_id, nick, value, visible, calculable, benefit_type, period_value, period_type, renewable, premium, chapter_id, parent, is_union, style_bold, style_important) VALUES (${coverage.original}, ${result.insertId}, ${coverage.nick ? `'${coverage.nick}'` : 'NULL'}, ${coverage.value ? `'${coverage.value}'` : 'NULL'}, ${coverage.visible}, ${coverage.calculable}, ${coverage.benefit_type ? `'${coverage.benefit_type}'` : 'NULL'}, ${coverage.period_value || 'NULL'}, ${coverage.period_type ? `'${coverage.period_type}'` : 'NULL'}, ${coverage.renewable}, ${coverage.premium || 0}, ${coverage.chapter_id || 'NULL'}, ${newParent}, ${coverage.is_union}, ${coverage.style_bold}, ${coverage.style_important})`;
          const insertResult = await sql_query(insertSql);
          idMap[coverage.idx] = insertResult.insertId;
          loadPrg.value++;
        }
        fetchPlans();
        loading.value = false;
        showToast('플랜이 라이브러리에 추가되었습니다', 'success');
      } catch (error) {
        console.error('플랜 복사 중 오류:', error);
        loading.value = false;
        showToast('플랜 가져오기 중 오류가 발생했습니다', 'error');
      }
    }

    function editSolution(b, solution) {
      showSolutionEdit.value = b;
      editingSolution.value = solution || null;
    }

    // formatMoney - 숫자 변환 보장
    function formatMoney(val) {
      const num = Number(val);
      if (!num || isNaN(num)) return '0원';
      return num.toLocaleString('ko-KR') + '원';
    }

    function formatRelativeDate(dateStr) {
      const now = new Date();
      const then = new Date(dateStr);
      const diffMs = now - then;
      const diffDay = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      if (diffDay < 0) return "미래";
      if (diffDay === 0) return "오늘";
      if (diffDay === 1) return "어제";
      if (diffDay === 2) return "그저께";
      if (diffDay < 7) return `${diffDay}일 전`;
      if (diffDay < 30) return `${Math.floor(diffDay / 7)}주 전`;
      if (diffDay < 365) return `${Math.floor(diffDay / 30)}달 전`;
      return `${Math.floor(diffDay / 365)}년 전`;
    }

    function getSolutionPrice(solution) {
      const relatedPlans = plans.value.filter(plan => plan.solution_id === solution.idx);
      if (relatedPlans.length === 0) return 0;
      return relatedPlans.reduce((sum, plan) => sum + parseFloat(plan.price || 0), 0);
    }

    function closeThisPage() {
      props.oth_showCALibrary(false);
    }

    async function reloadPage() {
      loading.value = true;
      loadingMent.value = '새로고침 중...';
      loadPrg.value = 0;
      laodMax.value = 5;
      try {
        await fetchCustomers(); loadPrg.value++;
        await fetchSolutions(); loadPrg.value++;
        await fetchPlans(); loadPrg.value++;
        await fetchPubPlans(); loadPrg.value++;
        await fetchPubSolutions(); loadPrg.value++;
      } catch (error) {
        console.error('페이지 새로고침 중 오류:', error);
      } finally {
        loading.value = false;
      }
    }

    async function handleCustomerRegistered() {
      await fetchCustomers();
      const sortedCustomersList = [...customers.value].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      if (sortedCustomersList.length > 0) {
        const latestCustomer = sortedCustomersList[0];
        await makeSolution(latestCustomer.idx);
      }
    }

    return {
      activeTab, workspaceView, searchQuery, searchFocused, planSearchQuery, planSearchFocused,
      showWorkspaceSort, workspaceSort, workspaceSortOptions, sortedCustomers, sortedPlans, getCurrentTabLabel, toggleCustomer, getTotalPrice,
      marketCategory, marketSort, marketSearchQuery, marketSearchFocused, showSortDropdown, marketFilter, sortOptions, getSortLabel, popularCompanies, filteredMarketSolutions, filteredMarketPlans,
      filteredCustomers, filteredPlans, customers, customersWithData, selectedCustomer, selectedCustomerId, selectedPlanId, selectedPlanData, selectCustomer, selectPlan,
      plans, solutions, pub_plans, pub_solutions, CA_openView, CA_openEdit, getInsuCompanyInfo, makeSolution, confirmDelete, confirmDeletePlan, deleteSolution, deletePlan,
      toPubPlan, toPubSolution, downloadPlan, downloadSolution, editingSolution, showSolutionEdit, editSolution, formatMoney, formatRelativeDate, fetchSolutions, fetchCustomers, fetchPubSolutions, getSolutionPrice, closeThisPage,
      member_info, calculateInsuAge, genderChoser, getSolStatus, loading, loadPrg, laodMax, useViewDialog, useEditDialog, selectedSolution, viewDialogOnOff, editDialogOnOff, reloadPage, loadingMent,
      showSolutionTypeSelector, showCustomerPicker, selectVirtual, openCustomerPicker, handleCustomerSelect, handleCustomerRegistered, openCustomerRegister, showCustomerRegister, customerRegisterSwitch,
      showPlanView, selectedPlanIdx, openPlanView, closePlanView, toast, showToast,
      feedbackRequests, feedbackFilter, filteredFeedbackRequests, pendingFeedbackCount, completedFeedbackCount, fetchFeedbackRequests, getFilterLabel, startReview, continueReview, viewCompletedReview,
    };
  }
};
</script>
<style scoped>
/* ========================================
   CSS Custom Properties
======================================== */
:root {
  --transition-fast: 0.15s ease;
  --transition-normal: 0.25s ease;
  --transition-slow: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-bounce: 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* ========================================
   Main Container
======================================== */
#module-CA-main {
  position: absolute;
  left: 0;
  top: 0;
  z-index: var(--z-index-top);
  width: 100%;
  height: 100%;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: linear-gradient(180deg, var(--color-ca-a) 0%, var(--color-background) 100%);
  font-family: var(--font-family-base);
  overflow: hidden;
}

#module-CA-main.is-loading {
  pointer-events: none;
}

/* ========================================
   Toast Notification
======================================== */
.toast {
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  padding: 14px 24px;
  background: var(--color-background);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 999999;
  font-weight: var(--font-weight-semibold);
  border: 1px solid var(--color-surface-reverse);
}

.toast.success { border-left: 4px solid #22c55e; }
.toast.success i { color: #22c55e; }
.toast.error { border-left: 4px solid #ef4444; }
.toast.error i { color: #ef4444; }
.toast.warning { border-left: 4px solid #f59e0b; }
.toast.warning i { color: #f59e0b; }
.toast.info { border-left: 4px solid var(--color-brand); }
.toast.info i { color: var(--color-brand); }
.toast i { font-size: 20px; }

.toast-enter-active, .toast-leave-active {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(20px) scale(0.9);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px) scale(0.9);
}

/* ========================================
   Loading Overlay
======================================== */
#loading-paper {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: var(--z-index-head);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.loading-spinner {
  position: relative;
  width: 80px;
  height: 80px;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: var(--color-brand);
  animation: spin 1s linear infinite;
}

.spinner-ring:nth-child(2) {
  width: 60%;
  height: 60%;
  top: 20%;
  left: 20%;
  border-top-color: var(--color-special-point);
  animation-duration: 0.8s;
  animation-direction: reverse;
}

.spinner-ring:nth-child(3) {
  width: 30%;
  height: 30%;
  top: 35%;
  left: 35%;
  border-top-color: var(--color-special-accent);
  animation-duration: 0.6s;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-content h2 {
  font-size: var(--font-size-xl);
  color: var(--color-text-white);
  font-weight: var(--font-weight-semibold);
  margin: 0;
}

.progress-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 200px;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--color-brand), var(--color-special-point));
  border-radius: 100px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.7);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* ========================================
   NEW: Top Navigation Bar 
   (기존 top-hd + main-header 대체)
======================================== */
.top-nav {
  width: 100%;
  max-width: 1400px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding-top: 12px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.nav-tabs {
  display: flex;
  gap: 8px;
}

.nav-tab {
  position: relative;
  width: 48px;
  height: 48px;
  background: var(--color-background);
  border: 2px solid var(--color-surface-reverse);
  border-radius: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: var(--color-text-secondary);
  transition: all 0.25s ease;
}

.nav-tab:hover {
  border-color: var(--color-brand);
  color: var(--color-brand);
  transform: translateY(-2px);
}

.nav-tab.active {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--color-text-white);
  box-shadow: 0 4px 16px rgba(var(--color-brand-rgb, 79, 70, 229), 0.3);
}

.nav-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #ef4444;
  color: white;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-title {
  display: flex;
  flex-direction: column;
}

.title-label {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.close-btn {
  width: 48px;
  height: 48px;
  background: var(--color-surface-reverse);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  font-size: var(--font-size-lg);
  border-radius: 14px;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: var(--color-special-warning);
  color: var(--color-text-white);
  transform: rotate(90deg);
}

/* ========================================
   Container Layout
======================================== */
.container {
  width: 100%;
  height: 100%;
  max-width: 1400px;
  margin: 0 auto;
  gap: 24px;
  display: flex;
  overflow: hidden;
}

.tab-slide-enter-active, .tab-slide-leave-active {
  transition: all 0.3s ease;
}
.tab-slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
.tab-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

/* ========================================
   Left Panel (Workspace) - 확장됨
======================================== */
.left-panel {
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
}

/* ========================================
   Panel Toolbar (뷰토글 + 검색 + 정렬)
======================================== */
.panel-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

/* View Toggle */
.view-toggle {
  display: flex;
  gap: 8px;
  background: var(--color-background);
  padding: 6px;
  border-radius: 14px;
  border: 1px solid var(--color-surface-reverse);
}

.view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-radius: 10px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.25s ease;
}

.view-btn:hover { color: var(--color-text-primary); }

.view-btn.active {
  background: var(--color-brand);
  color: var(--color-text-white);
  box-shadow: 0 2px 8px rgba(var(--color-brand-rgb, 79, 70, 229), 0.3);
}

.view-btn .badge {
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  font-size: var(--font-size-xs);
}

.view-btn:not(.active) .badge {
  background: var(--color-surface-reverse);
}

/* Toolbar Controls (검색 + 정렬) */
.toolbar-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Search Box */
.search-box {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--color-background);
  border: 2px solid var(--color-surface-reverse);
  border-radius: 12px;
  padding: 10px 14px;
  transition: all 0.2s ease;
  min-width: 200px;
}

.search-box.focused {
  border-color: var(--color-brand);
  box-shadow: 0 0 0 4px rgba(var(--color-brand-rgb, 79, 70, 229), 0.1);
}

.search-box i {
  color: var(--color-text-secondary);
  font-size: var(--font-size-lg);
}

.search-box input {
  flex: 1;
  border: none;
  outline: none;
  font-size: var(--font-size-sm);
  background: transparent;
  color: var(--color-text-primary);
  min-width: 100px;
}

.search-box input::placeholder { color: var(--color-text-secondary); }

.clear-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface-reverse);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--color-text-secondary);
  transition: all 0.2s;
}

.clear-btn:hover {
  background: var(--color-special-warning);
  color: var(--color-text-white);
}

/* Sort Dropdown */
.sort-dropdown {
  position: relative;
}

.sort-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: var(--color-background);
  border: 2px solid var(--color-surface-reverse);
  border-radius: 12px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.sort-btn:hover {
  border-color: var(--color-brand);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 160px;
  background: var(--color-background);
  border: 1px solid var(--color-surface-reverse);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 100;
  overflow: hidden;
}

.dropdown-menu button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.dropdown-menu button:hover {
  background: var(--color-surface-light);
}

.dropdown-menu button.active {
  background: rgba(var(--color-brand-rgb, 79, 70, 229), 0.1);
  color: var(--color-brand);
}

.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.2s ease;
}
.dropdown-enter-from, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* ========================================
   Add Button
======================================== */
.add-btn {
  width: 100%;
  padding: 20px;
  background: linear-gradient(135deg, rgba(var(--color-brand-rgb, 79, 70, 229), 0.05), rgba(var(--color-brand-rgb, 79, 70, 229), 0.1));
  border: 2px dashed var(--color-brand);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.add-btn:hover {
  background: linear-gradient(135deg, rgba(var(--color-brand-rgb, 79, 70, 229), 0.1), rgba(var(--color-brand-rgb, 79, 70, 229), 0.15));
  border-style: solid;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--color-brand-rgb, 79, 70, 229), 0.2);
}

.add-btn-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.add-icon {
  width: 48px;
  height: 48px;
  background: var(--color-brand);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-white);
  font-size: 24px;
  transition: all 0.3s ease;
}

.add-btn:hover .add-icon { transform: rotate(90deg); }

.add-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.add-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-brand);
}

.add-desc {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.add-arrow {
  color: var(--color-brand);
  font-size: var(--font-size-xl);
  transition: transform 0.3s ease;
}

.add-btn:hover .add-arrow { transform: translateX(4px); }

/* ========================================
   Empty States
======================================== */
.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  background: var(--color-surface-reverse);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.empty-icon i {
  font-size: 36px;
  color: var(--color-text-secondary);
}

.empty-state h3 {
  margin: 0 0 8px 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.empty-state p {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  max-width: 280px;
}

/* ========================================
   Customer Items (아코디언 스타일)
======================================== */
.customer-items {
  flex: 1;
  min-height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 8px;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Customer Card - 아코디언 */
.customer-card {  
  flex-shrink: 0;
  background: var(--color-background);
  border-radius: 16px;
  border: 2px solid transparent;
  transition: all 0.25s ease;
  overflow: hidden;
  animation: slideInUp 0.4s ease backwards;
  animation-delay: var(--delay, 0s);
}

.customer-card:hover {
  border-color: var(--color-brand);
}

.customer-card.active {
  border-color: var(--color-brand);
  box-shadow: 0 4px 16px rgba(var(--color-brand-rgb, 79, 70, 229), 0.15);
}

.customer-card.unassigned {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.05), rgba(239, 68, 68, 0.1));
  border: 2px dashed rgba(239, 68, 68, 0.5);
}

.customer-card.unassigned.active {
  border-style: solid;
  border-color: #ef4444;
}

/* Customer Header (클릭 영역) */
.customer-header {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 14px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.customer-header:hover {
  background: var(--color-surface-light);
}

.customer-header .profile {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  overflow: hidden;
  background: var(--color-surface-reverse);
  flex-shrink: 0;
}

.customer-header .profile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.customer-header .profile.warning::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(239, 68, 68, 0.2);
}

.warning-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 22px;
  height: 22px;
  background: #ef4444;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  border: 2px solid var(--color-background);
}

.customer-header .info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.name-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.name {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.suffix {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.sol-count {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
  gap: 6px;
}

.sol-count i { font-size: var(--font-size-base); }

/* Expand Icon */
.expand-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  transition: all 0.3s ease;
}

.expand-icon.expanded {
  transform: rotate(180deg);
  color: var(--color-brand);
}

/* Solutions Wrapper (펼쳐지는 영역) */
.solutions-wrapper {
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.solution-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  background: var(--color-background-light);
  border-radius: 12px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.solution-item:hover {
  background: var(--color-surface-light);
  border-color: var(--color-surface-reverse);
}

.solution-item.warning {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.05), rgba(239, 68, 68, 0.1));
  border: 1px dashed rgba(239, 68, 68, 0.3);
}

.solution-main {
  flex: 1;
  cursor: pointer;
  min-width: 0;
}

.solution-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.chip-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chip {
  display: inline-block;
  background: var(--color-special-point);
  color: var(--color-text-white);
  padding: 4px 12px;
  border-radius: 8px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.public-icon {
  color: #8b5cf6;
  font-size: 16px;
}

.meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  flex-wrap: wrap;
}

.meta .date {
  display: flex;
  align-items: center;
  gap: 4px;
}

.meta .divider { color: var(--color-surface-reverse); }

.meta .price {
  font-weight: var(--font-weight-semibold);
  color: var(--color-brand);
}

.solution-actions {
  display: flex;
  gap: 6px;
}

.btn-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background);
  border: 1px solid var(--color-surface-reverse);
  border-radius: 10px;
  font-size: var(--font-size-base);
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--color-text-secondary);
}

.btn-icon:hover { transform: translateY(-2px); }

.btn-icon.view:hover {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--color-text-white);
}

.btn-icon.share:hover {
  background: #8b5cf6;
  border-color: #8b5cf6;
  color: white;
}

.btn-icon.danger:hover {
  background: #ef4444;
  border-color: #ef4444;
  color: var(--color-text-white);
}

/* Expand Animation */
.expand-enter-active, .expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}
.expand-enter-from, .expand-leave-to {
  opacity: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.expand-enter-to, .expand-leave-from {
  max-height: 500px;
}

/* List animation */
.list-enter-active, .list-leave-active {
  transition: all 0.3s ease;
}
.list-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* ========================================
   Plan Grid (라이브러리 뷰)
======================================== */
.plan-grid {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  padding-right: 8px;
  align-content: start;
}

.plan-card {
  position: relative;
  background: var(--color-background);
  border: 2px solid transparent;
  border-radius: 16px;
  padding: 18px;
  cursor: pointer;
  transition: all 0.25s ease;
  animation: slideInUp 0.3s ease backwards;
  animation-delay: var(--delay, 0s);
}

.plan-card:hover {
  border-color: var(--color-brand);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.plan-card.active {
  border-color: var(--color-brand);
  background: linear-gradient(135deg, rgba(var(--color-brand-rgb, 79, 70, 229), 0.05), rgba(var(--color-brand-rgb, 79, 70, 229), 0.1));
}

.plan-card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
}

.plan-company-logo {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: var(--color-surface-reverse);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.plan-company-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 6px;
}

.plan-card-info {
  flex: 1;
  min-width: 0;
}

.plan-name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.plan-company {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.plan-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 14px;
  border-top: 1px solid var(--color-surface-reverse);
}

.plan-price {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-brand);
}

.plan-date {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.plan-card-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.plan-card:hover .plan-card-actions {
  opacity: 1;
}

.btn-mini {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background);
  border: 1px solid var(--color-surface-reverse);
  border-radius: 8px;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  transition: all 0.2s;
}

.btn-mini:hover {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: white;
}

.btn-mini.danger:hover {
  background: #ef4444;
  border-color: #ef4444;
}

/* ========================================
   Right Panel - 축소 (요약 패널)
======================================== */
.right-panel {
  width: 320px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  background: var(--color-background);
  padding: 24px;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid var(--color-surface-reverse);
}

.summary-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-surface-reverse);
}

.summary-header i {
  font-size: var(--font-size-xl);
  color: var(--color-brand);
}

.summary-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.summary-profile {
  text-align: center;
  padding: 20px;
  background: var(--color-surface-light);
  border-radius: 16px;
}

.summary-profile img {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  object-fit: cover;
  margin-bottom: 12px;
  border: 3px solid var(--color-background);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.summary-profile.plan img {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  object-fit: contain;
  padding: 8px;
  background: var(--color-background);
}

.summary-name {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: 4px;
}

.summary-tag {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.summary-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.summary-stats .stat-item {
  text-align: center;
  padding: 16px;
  background: var(--color-surface-light);
  border-radius: 12px;
}

.summary-stats .stat-value {
  display: block;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-brand);
  margin-bottom: 4px;
}

.summary-stats .stat-label {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.summary-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: var(--color-surface-light);
  border-radius: 10px;
}

.detail-row .label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.detail-row .value {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.detail-row .value.highlight {
  color: var(--color-brand);
  font-size: var(--font-size-base);
}

.summary-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px;
  background: var(--color-brand);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all 0.2s;
  margin-top: auto;
}

.summary-action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(var(--color-brand-rgb, 79, 70, 229), 0.3);
}

.summary-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--color-text-secondary);
}

.summary-empty i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.summary-empty p {
  margin: 0;
  font-size: var(--font-size-sm);
}

/* ========================================
   Modal Dialog
======================================== */
#dialog-solutionTypeSelector {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

.dialog-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.dialog-content {
  position: relative;
  z-index: 1;
  width: 90%;
  max-width: 500px;
}

.paper-small {
  background: var(--color-background);
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2);
}

.header-small {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.header-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--color-brand), var(--color-special-point));
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: var(--color-text-white);
  flex-shrink: 0;
}

.header-text { flex: 1; }

.header-text h2 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.header-text p {
  margin: 6px 0 0 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.close-btn-small {
  width: 40px;
  height: 40px;
  background: var(--color-surface-reverse);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  font-size: var(--font-size-lg);
  border-radius: 12px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.close-btn-small:hover {
  background: var(--color-special-warning);
  color: var(--color-text-white);
  transform: rotate(90deg);
}

.options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.option-btn {
  width: 100%;
  padding: 20px;
  background: var(--color-background-light);
  border: 2px solid var(--color-surface-reverse);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  text-align: left;
}

.option-btn:hover {
  border-color: var(--color-brand);
  background: linear-gradient(135deg, rgba(var(--color-brand-rgb, 79, 70, 229), 0.05), rgba(var(--color-brand-rgb, 79, 70, 229), 0.1));
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.option-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  flex-shrink: 0;
}

.option-icon.new {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: white;
}

.option-icon.existing {
  background: linear-gradient(135deg, var(--color-brand), var(--color-special-point));
  color: white;
}

.option-content { flex: 1; }

.option-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  display: block;
  margin-bottom: 4px;
}

.option-desc {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.option-arrow {
  font-size: var(--font-size-xl);
  color: var(--color-text-secondary);
  transition: all 0.25s ease;
}

.option-btn:hover .option-arrow {
  color: var(--color-brand);
  transform: translateX(4px);
}

.modal-enter-active, .modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-active .dialog-backdrop,
.modal-leave-active .dialog-backdrop {
  transition: opacity 0.3s ease;
}

.modal-enter-active .paper-small,
.modal-leave-active .paper-small {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-enter-from, .modal-leave-to { opacity: 0; }

.modal-enter-from .dialog-backdrop,
.modal-leave-to .dialog-backdrop { opacity: 0; }

.modal-enter-from .paper-small {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
}

.modal-leave-to .paper-small {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

/* ========================================
   Market Tab
======================================== */
.market-container {
  flex-direction: column;
  overflow: hidden;
}

.market-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: var(--color-background);
  border-radius: 20px;
  border: 1px solid var(--color-surface-reverse);
}

.market-title-section h2 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.market-title-section p {
  margin: 4px 0 0 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.market-stats {
  display: flex;
  gap: 24px;
}

.market-stat {
  text-align: center;
}

.market-stat .value {
  display: block;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-brand);
}

.market-stat .label {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.market-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.category-tabs {
  display: flex;
  gap: 8px;
  padding: 6px;
  background: var(--color-background);
  border-radius: 14px;
  border: 1px solid var(--color-surface-reverse);
}

.category-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: transparent;
  border: none;
  border-radius: 10px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.25s ease;
}

.category-tab i {
  font-size: var(--font-size-lg);
}

.category-tab:hover {
  color: var(--color-text-primary);
}

.category-tab.active {
  background: var(--color-brand);
  color: white;
}

.market-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.market-search {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: var(--color-background);
  border: 1px solid var(--color-surface-reverse);
  border-radius: 12px;
  transition: all 0.3s ease;
  width: 200px;
}

.market-search.expanded {
  width: 280px;
  border-color: var(--color-brand);
  box-shadow: 0 0 0 4px rgba(var(--color-brand-rgb, 79, 70, 229), 0.1);
}

.market-search i {
  color: var(--color-text-secondary);
  font-size: var(--font-size-lg);
}

.market-search input {
  flex: 1;
  border: none;
  outline: none;
  font-size: var(--font-size-sm);
  background: transparent;
  color: var(--color-text-primary);
}

.sort-wrapper {
  position: relative;
}

.company-filter {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.company-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--color-background);
  border: 1px solid var(--color-surface-reverse);
  border-radius: 100px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
}

.company-chip:hover {
  border-color: var(--color-brand);
  color: var(--color-text-primary);
}

.company-chip.active {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: white;
}

.company-chip img {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  object-fit: contain;
}

.market-content {
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
}

.grid-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.market-card {
  position: relative;
  background: var(--color-background);
  border: 1px solid var(--color-surface-reverse);
  border-radius: 20px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.market-card:hover {
  border-color: var(--color-brand);
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
}

.market-card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.card-logo {
  width: 48px;
  height: 48px;
  background: var(--color-surface-light);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.card-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 8px;
}

.card-logo i {
  font-size: 24px;
  color: var(--color-brand);
}

.card-info {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-subtitle {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.market-card-body {
  margin-bottom: 16px;
}

.card-meta {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.meta-item i {
  font-size: var(--font-size-base);
}

.market-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid var(--color-surface-reverse);
}

.card-price {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-brand);
}

.card-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border: none;
  border-radius: 10px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn.primary {
  background: var(--color-brand);
  color: white;
}

.action-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--color-brand-rgb, 79, 70, 229), 0.3);
}

/* ========================================
   Admin Tab
======================================== */
.admin-container {
  flex-direction: column;
  overflow-y: auto;
}

.admin-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 8px;
  flex: 1;
  overflow-y: auto;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: var(--color-background);
  border-radius: 20px;
  border: 1px solid var(--color-surface-reverse);
  flex-wrap: wrap;
  gap: 20px;
}

.admin-title-section h2 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.admin-title-section p {
  margin: 4px 0 0 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.admin-stats {
  display: flex;
  gap: 16px;
}

.admin-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 12px;
}

.admin-stat.pending {
  background: rgba(245, 158, 11, 0.1);
}

.admin-stat.complete {
  background: rgba(34, 197, 94, 0.1);
}

.admin-stat i {
  font-size: 20px;
}

.admin-stat.pending i {
  color: #f59e0b;
}

.admin-stat.complete i {
  color: #22c55e;
}

.admin-stat .value {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.admin-stat .label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.admin-filter {
  display: flex;
  gap: 8px;
  padding: 6px;
  background: var(--color-background);
  border-radius: 14px;
  border: 1px solid var(--color-surface-reverse);
  width: fit-content;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background: transparent;
  border: none;
  border-radius: 10px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.filter-btn:hover {
  color: var(--color-text-primary);
  background: var(--color-surface-reverse);
}

.filter-btn.active {
  background: var(--color-brand);
  color: white;
}

.request-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.request-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--color-background);
  border: 2px solid transparent;
  border-radius: 16px;
  transition: all 0.25s ease;
}

.request-item:hover {
  border-color: var(--color-brand);
  transform: translateX(4px);
}

.request-avatar {
  width: 48px;
  height: 48px;
  background: var(--color-surface-reverse);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: var(--color-text-secondary);
  flex-shrink: 0;
}

.request-info {
  flex: 1;
  min-width: 0;
}

.request-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: 4px;
}

.request-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.request-status {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
}

.request-status.requested {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
}

.request-status.in_progress {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.request-status.complete {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.request-actions {
  display: flex;
  gap: 8px;
}

/* ========================================
   Scrollbars
======================================== */
.customer-items::-webkit-scrollbar,
.plan-grid::-webkit-scrollbar,
.market-content::-webkit-scrollbar,
.admin-content::-webkit-scrollbar {
  width: 6px;
}

.customer-items::-webkit-scrollbar-track,
.plan-grid::-webkit-scrollbar-track,
.market-content::-webkit-scrollbar-track,
.admin-content::-webkit-scrollbar-track {
  background: transparent;
}

.customer-items::-webkit-scrollbar-thumb,
.plan-grid::-webkit-scrollbar-thumb,
.market-content::-webkit-scrollbar-thumb,
.admin-content::-webkit-scrollbar-thumb {
  background: var(--color-surface-reverse);
  border-radius: 3px;
}

/* ========================================
   Responsive Design
======================================== */
@media (max-width: 1200px) {
  .container {
    flex-direction: column;
  }
  
  .left-panel {
    max-height: 60%;
  }
  
  .right-panel {
    width: 100%;
    min-width: auto;
    max-height: 40%;
  }

  .summary-stats {
    grid-template-columns: repeat(4, 1fr);
  }

  .market-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 900px) {
  .right-panel {
    display: none;
  }

  .left-panel {
    max-height: 100%;
  }
}

@media (max-width: 768px) {
  #module-CA-main {
    padding: 0 12px 12px 12px;
  }
  
  .top-nav {
    height: auto;
    flex-wrap: wrap;
    gap: 12px;
    padding-top: 8px;
  }

  .nav-left {
    flex-wrap: wrap;
    gap: 12px;
  }

  .nav-tab {
    width: 44px;
    height: 44px;
    font-size: 20px;
  }

  .title-label {
    font-size: var(--font-size-lg);
  }

  .panel-toolbar {
    flex-direction: column;
    gap: 12px;
  }

  .view-toggle {
    width: 100%;
  }

  .view-btn {
    flex: 1;
    justify-content: center;
  }

  .toolbar-controls {
    width: 100%;
  }

  .search-box {
    flex: 1;
    min-width: auto;
  }

  .plan-grid {
    grid-template-columns: 1fr;
  }

  .grid-items {
    grid-template-columns: 1fr;
  }

  .market-nav {
    flex-direction: column;
    align-items: stretch;
  }
  
  .category-tabs {
    width: 100%;
  }
  
  .category-tab {
    flex: 1;
    justify-content: center;
  }
  
  .market-controls {
    width: 100%;
    flex-direction: column;
  }
  
  .market-search {
    width: 100%;
  }

  .admin-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .admin-filter {
    width: 100%;
    overflow-x: auto;
  }
  
  .request-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .request-actions {
    width: 100%;
    margin-top: 12px;
  }
  
  .action-btn {
    flex: 1;
    justify-content: center;
  }

  .paper-small {
    padding: 20px;
    border-radius: 20px;
  }
  
  .header-icon {
    width: 48px;
    height: 48px;
    font-size: 24px;
    border-radius: 14px;
  }
  
  .option-icon {
    width: 44px;
    height: 44px;
    font-size: 22px;
    border-radius: 12px;
  }
  
  .option-btn { padding: 16px; }
}
</style>